<template>
  <transition
    @enter="enter"
    @leave="leave"
  >
    <div
      v-show="isVisible"
      :class="[`s-alert`, `s-alert--${type}`]"
    >
      <div class="container">
        <div class="s-alert--wrapper">
          <svg-info
            v-if="type === 'info' || type === 'warning'"
            class="s-alert__icon"
          ></svg-info>

          <svg-success
            v-if="type === 'success'"
            class="s-alert__icon"
          ></svg-success>

          <svg-error
            v-if="type === 'error'"
            class="s-alert__icon"
          ></svg-error>

          <div
            v-if="title"
            class="h4 s-alert__title"
            v-html="title"
          ></div>

          <div
            v-if="description"
            class="small s-alert__description"
            v-html="description"
          ></div>

          <div
            v-if="!!$slots.buttons"
            class="s-alert__buttons"
          >
            <slot name="buttons"></slot>
          </div>

          <button
            class="s-alert__close-button"
            type="button"
            @click="() => $emit('closeClick')"
          >
            <svg-close></svg-close>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import SvgInfo from '~/assets/icons/alert/infoAlert.svg'
import SvgError from '~/assets/icons/alert/errorAlert.svg'
import SvgSuccess from '~/assets/icons/alert/successAlert.svg'
import SvgClose from '~/assets/icons/common/close.svg'

export default {
  name: 'SAlert',
  components: {
    SvgInfo,
    SvgError,
    SvgSuccess,
    SvgClose
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      validator(value) {
        return ['success', 'warning', 'info', 'error'].indexOf(value) !== -1
      }
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    enter(target, done) {
      this.$velocity(target, 'slideDown', {duration: 300}, {complete: done})
    },
    leave(target, done) {
      this.$velocity(target, 'slideUp', {duration: 300}, {complete: done})
    }
  }
}
</script>

<style lang="scss">
.s-alert--info {
  background-color: $gray50;
}

.s-alert--success {
  //TODO $green5
  background-color: #F5FBF8;
}

.s-alert--warning {
  //TODO ???
  background-color: #FFFCF4;

  svg {
    //TODO ???
    fill: #FFC01E;
  }
}

.s-alert--error {
  //TODO ???
  background-color: #FEF5F6;
}

.s-alert--wrapper {
  padding: 16px 0 16px 40px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  @media (max-width: $breakpoint-lg) {
    padding-left: 34px;
  }

  @media (max-width: $breakpoint-md) {
    padding-left: 30px;
  }
}

.s-alert__icon {
  position: absolute;
  top: 16px;
  left: 0;
  max-width: 24px;
  max-height: 24px;

  @media (max-width: $breakpoint-md) {
    width: 20px;
    height: 20px;
  }
}

.s-alert__close-button {
  padding: 0;
  position: absolute;
  top: 16px;
  right: 0;
  border: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
  }
}

.s-alert__title {
  margin-bottom: 4px;
  padding-right: 30px;

  @media (max-width: $breakpoint-md) {
    margin-bottom: 8px;
  }
}

.s-alert__buttons {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;

  .btn {
    margin-right: 8px;
    margin-top: 8px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>